module.exports = __webpack_public_path__ + "img/main.32c79438.jpg";